document.addEventListener("DOMContentLoaded", function () {
  // Enable Day.js plugins
  if (typeof dayjs !== 'undefined') {
    dayjs.extend(window.dayjs_plugin_utc);
    dayjs.extend(window.dayjs_plugin_timezone);
    dayjs.extend(window.dayjs_plugin_customParseFormat);
  }

  const nowPH = dayjs().tz("Asia/Manila");
  const cutoffHour = 18; // 6 PM
  const minimumAdvanceHours = 2;
  const maxDaysAhead = 13;

  const timeslots = [
    "08:00 AM - 10:00 AM",
    "10:00 AM - 12:00 PM",
    "12:00 PM - 02:00 PM",
    "02:00 PM - 04:00 PM",
    "04:00 PM - 06:00 PM",
    "06:00 PM - 08:00 PM",
    "08:00 PM - 10:00 PM"
  ];

  function showError(message) {
    const errorDiv = document.getElementById('delivery-error');
    errorDiv.textContent = message;
    errorDiv.style.display = 'block';
    errorDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideError() {
    const errorDiv = document.getElementById('delivery-error');
    errorDiv.style.display = 'none';
  }

  function handleTimeSlotSelection() {
    const selectedSlot = document.querySelector('input[name="attributes[Delivery Time]"]:checked');
    if (selectedSlot && window.innerWidth <= 768) {
      const slotContainer = document.getElementById("time-slot-container");
      slotContainer.style.maxHeight = '60px';
      slotContainer.style.overflow = 'hidden';

      setTimeout(() => {
        let selectedTimeDisplay = slotContainer.querySelector('.selected-time');
        if (!selectedTimeDisplay) {
          selectedTimeDisplay = document.createElement('p');
          selectedTimeDisplay.className = 'selected-time';
          slotContainer.insertBefore(selectedTimeDisplay, slotContainer.firstChild.nextSibling);
        }
        selectedTimeDisplay.textContent = `Selected: ${selectedSlot.value}`;
        selectedTimeDisplay.style.display = 'block';
      }, 300);
    }
  }

  // Initialize Flatpickr
  if (typeof flatpickr !== 'undefined') {
    flatpickr("#delivery-date", {
      minDate: "today",
      maxDate: new Date().fp_incr(maxDaysAhead),
      dateFormat: "Y-m-d",
      disableMobile: true,
      onChange: function(selectedDates, dateStr) {
        hideError();
        const slotContainer = document.getElementById("time-slot-container");
        slotContainer.style.maxHeight = 'none';
        slotContainer.style.overflow = 'visible';

        // Clear existing slots
        slotContainer.querySelectorAll('.time-slot-option').forEach(slot => slot.remove());

        let availableSlots = [...timeslots];

        if (dateStr === nowPH.format("YYYY-MM-DD")) {
          if (nowPH.hour() >= cutoffHour) {
            availableSlots = [];
            const errorMsg = document.createElement('p');
            errorMsg.className = 'time-slot-option error-message';
            errorMsg.style.color = '#d32f2f';
            errorMsg.textContent = 'Same-day delivery cutoff has passed (6:00 PM). Please select another date.';
            slotContainer.appendChild(errorMsg);
          } else {
            const bufferTime = nowPH.add(minimumAdvanceHours, 'hour');
            availableSlots = timeslots.filter(slot => {
              const slotStart = dayjs.tz(`${dateStr} ${slot.split(" - ")[0]}`, "YYYY-MM-DD hh:mm A", "Asia/Manila");
              return slotStart.isAfter(bufferTime);
            });
          }
        }

        if (availableSlots.length > 0) {
          availableSlots.forEach(slot => {
            const slotId = "slot-" + slot.replace(/\s+/g, "-").replace(/:/g, "");
            const slotDiv = document.createElement('div');
            slotDiv.className = 'time-slot-option';
            slotDiv.innerHTML = `
              <label for="${slotId}" class="time-slot-label">
                <input type="radio" id="${slotId}" name="attributes[Delivery Time]" value="${slot}" required>
                <span class="time-slot-text">${slot}</span>
                <span class="time-slot-checkmark"></span>
              </label>
            `;
            slotContainer.appendChild(slotDiv);

            slotDiv.querySelector('input[type="radio"]').addEventListener('change', handleTimeSlotSelection);
          });
        } else if (dateStr !== nowPH.format("YYYY-MM-DD")) {
          const noSlotsMsg = document.createElement('p');
          noSlotsMsg.className = 'time-slot-option';
          noSlotsMsg.textContent = 'No delivery slots available for this date.';
          slotContainer.appendChild(noSlotsMsg);
        }
      }
    });
  }

  // Checkout validation
  function validateDeliverySelection(e) {
    const deliveryDate = document.querySelector('#delivery-date').value;
    const deliveryTime = document.querySelector('input[name="attributes[Delivery Time]"]:checked');

    if (!deliveryDate) { e.preventDefault(); showError('Please select a delivery date.'); return false; }
    if (!deliveryTime) { e.preventDefault(); showError('Please select a delivery time slot.'); return false; }
    hideError();
    return true;
  }

  const checkoutSelectors = [
    '[name="checkout"]',
    '.checkout-button',
    '.btn--checkout',
    'input[type="submit"][name="checkout"]',
    '.cart__checkout-button',
    '[data-checkout-button]'
  ];

  checkoutSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(button => {
      button.addEventListener('click', validateDeliverySelection);
    });
  });

  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) cartForm.addEventListener('submit', validateDeliverySelection);
});
